import React, {FC} from 'react';
import {Tag, TagProps} from 'antd';
import classNames from 'classnames';

interface LiveTagProps extends TagProps {
    text?: string;
}

const LiveTag: FC<LiveTagProps> = ({text, className, ...otherProps}) => {
    return (
        <Tag className={classNames('tag-live', className)} {...otherProps}>
            {text ?? 'Live'}
        </Tag>
    );
};

export default LiveTag;
